export default "__VITE_ASSET__D0VIHr2q__"